export default __webpack_public_path__ + "static/media/eadplataforma.0eca9efd.png";